module.exports = __webpack_public_path__ + "img/S1.3be1e406.svg";